import axios from 'axios';

export default {
  install(app) {
    app.mixin({
      methods: {
        $proxyCheck() {
          const brandId = this.brand_slug || this.setbrandid || this.brandSlug;
          if (!brandId) return;

          const data = { brand_id: brandId };
          
          axios.post(
            "https://api.rezcomm.com/srchana/iplatlon",
            data,
            {
              headers: {
                secret_id: 'ed6a467528707c07fad1540f4820cc2a',
                secret_key: '429cc1c9a706d77fa23c5aa82cf2b30d357e4c02f4522f09',
                "Content-Type": "application/json",
              },
            }
          ).then((response) => {
            const responseData = response?.data;
            if (responseData) {
              const { anonymous = "false", proxy = "false", vpn = "false", tor = "false" } = responseData;
              if (anonymous === "true" || proxy === "true" || vpn === "true" || tor === "true") {
                window.location.href = "/proxycheck.html";
              }
            }
          }).catch((error) => {
            console.error("Proxy check failed", error);
          });
        }
      }
    });
  }
};
